import React from "react";
import { Navigation, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom'
import hero1 from '../../images/slider/edu1.jpg'
import hero2 from '../../images/slider/edu2.jpg'
import hero3 from '../../images/slider/edu3.jpg'
import hero4 from '../../images/slider/edu4.jpg'


const Edufair = () => {
    return (

        <section className="hero-slider hero-style-1">
            <Swiper
                // install Swiper modules
                modules={[Navigation, A11y, Autoplay]}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                speed={1800}
                parallax={true}
                navigation
                autoplay={{
                    delay: 3000, // 3000ms = 3 seconds
                    disableOnInteraction: false, // Allows autoplay to continue after user interaction
                }}
            >
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero1})` }}>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero2})` }}>
                    </div>
                </SwiperSlide>
                ...
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero3})` }}>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero4})` }}>
                    </div>
                </SwiperSlide>
            </Swiper>
        </section>
    )
}

export default Edufair;